// Translation strings for the application
// Add new languages by creating new objects with the same keys

const en = {
    // Module names
    'module.photo': 'Real Photo',
    'module.packshot': 'Product Session',
    'module.mockup': 'Digital Mockup',
    'module.illustration': 'Illustration',
    'module.infographic': 'Infographic',
    'module.short.packshot': 'Product',
    'module.short.photo': 'Photo',
    'module.short.mockup': 'Mockup',
    'module.short.infographic': 'Info',
    'module.short.illustration': 'Art',
    'nav.home': 'Home',
    'nav.gallery': 'Gallery',
    'nav.account': 'Account',
    'nav.create': 'Create',
    'guest.banner.message': 'You are using guest mode. Register for free to save your work and sync projects.',
    'guest.saveBanner.message': '{{remaining}} free generations left. Create an account so you don\'t lose this image.',
    'guest.saveBanner.cta': 'Create free account',
    'guest.saveBanner.signIn': 'Sign in',
    'guestConsent.title': 'Free version - public images',
    'guestConsent.message':
      'In the free version, your generated images are public and may be used by Paqshot for marketing and promotional purposes.',
    'guestConsent.privateHint':
      'Want to keep your images private? Create a free account - registered users get private storage for their work.',
    'guestConsent.acceptPrefix': 'I understand and accept the',
    'guestConsent.continue': 'Continue with free version',
    'auth.registerFree': 'Register for free',
    'packshots.sessionLockMessage': 'Product Session can be selected only at the beginning. Start a new session to change this mode.',
    'packshots.studioSetup': 'Studio settings',
    'packshots.studioBackgroundColor': 'Background color',
    'packshots.studioCameraDistance': 'Camera distance',
    'packshots.studioCustomHex': 'Custom HEX',
    'packshots.studioHexFormat': 'Format: #RRGGBB',
    'trial.active': 'Trial active: {{days}} {{daysLabel}} left',
    'trial.day': 'day',
    'trial.days': 'days',
    'trial.upgradeNow': 'Upgrade now',
    'trial.openBilling': 'Open billing',
    'trial.ended': 'Trial ended. Add a plan to continue.',
    'trial.subscriptionActive': 'Subscription active',
    'dashboard.customSolutions.title': 'Need Custom Solutions?',
    'dashboard.customSolutions.dev.title': 'Need custom software development?',
    'dashboard.customSolutions.dev.desc': 'We build custom web applications, mobile apps, and software solutions tailored to your business needs.',
    'dashboard.customSolutions.dev.link': 'Check squares.agency →',
    'dashboard.customSolutions.design.title': 'Need help with design, branding, product design?',
    'dashboard.customSolutions.design.desc': 'Professional design services for brands, products, and digital experiences that stand out.',
    'dashboard.customSolutions.design.link': 'Check 2rep.studio →',
    'settings.ssoNotice': 'Account settings are now available centrally in ProseCaptain SSO.',
    'settings.openSso': 'Click here to open settings',
    'account.billing': 'Billing',
    'account.settings': 'Settings',
    'account.logout': 'Log out',
    'account.credits': '{{count}} credits',
    'account.defaultName': 'Account',
    'account.defaultWorkspace': 'My Workspace',
    'language.label': 'Language',
    'language.en': 'English',
    'language.pl': 'Polski',

    // Image Style
    'imageStyle.title': 'Image Style',
    'imageStyle.photo': 'Real Photo',
    'imageStyle.illustration': 'Illustration',
    'imageStyle.infographic': 'Infographic',

    // Scene Type
    'sceneType.title': 'Scene Type',
    'sceneType.auto': 'Auto / General',
    'sceneType.action': 'Action Scene',
    'sceneType.mockup': 'Digital Mockup',
    'sceneType.abstract': 'Abstract Background',
    'sceneType.product_packshot': 'Product Packshot',

    // Device
    'device.title': 'Select device',
    'device.iphone': 'iPhone',
    'device.ipad': 'iPad / Tablet',
    'device.macbook': 'MacBook',
    'device.imac': 'iMac',
    'device.laptop_hp_with_greenscreen': 'Laptop HP with greenscreen',
    'device.generic_laptop': 'Generic laptop',

    // People Options
    'people.auto': 'Auto',
    'people.with_people': 'With people',
    'people.without_people': 'Without people',

    // Gender Options
    'gender.diverse': 'Diverse (mixed)',
    'gender.women': 'Women',
    'gender.men': 'Men',
    'gender.non_binary': 'Non-binary',

    // Ethnicity Options
    'ethnicity.diverse': 'Diverse (mixed)',
    'ethnicity.caucasian': 'Caucasian',
    'ethnicity.african': 'African',
    'ethnicity.asian': 'Asian',
    'ethnicity.hispanic': 'Hispanic',
    'ethnicity.middle_eastern': 'Middle Eastern',

    // Age Range Options
    'age.all': 'All ages',
    'age.children': 'Children (0-12)',
    'age.teens': 'Teens (13-19)',
    'age.young_adults': 'Young Adults (20-35)',
    'age.adults': 'Adults (36-55)',
    'age.seniors': 'Seniors (56+)',

    // Location
    'location.title': 'Location',
    'location.none': 'Auto',
    'location.custom': 'Custom (enter your own)',
    'location.customPlaceholder': 'Enter custom location',
    // Fallback locations
    'location.office': 'Office / Workspace',
    'location.home': 'Home / Interior',
    'location.outdoor': 'Outdoor',
    'location.cafe': 'Cafe / Restaurant',
    'location.studio': 'Photo Studio',
    'location.urban': 'Urban / City',
    'location.nature': 'Nature / Greenery',
    'location.industrial': 'Industrial / Loft',
    'location.minimal': 'Minimal Interior',
    'location.luxury': 'Luxury Interior',

    // People
    'people.title': 'People',
    'people.gender': 'Gender',
    'people.ethnicity': 'Ethnicity',
    'people.age': 'Age Range',
    'people.count': 'Number of people',
    'people.interaction': 'Interaction with product',
    'people.interaction.none': 'Auto',
    'people.interaction.holding': 'Holding product',
    'people.interaction.using': 'Using product',
    'people.interaction.looking_at': 'Looking at product',
    'people.interaction.pointing': 'Pointing to product',
    'people.interaction.in_background': 'In background',
    'people.editDetails': 'Edit People Details',

    // Aspect Ratio
    'aspectRatio.title': 'Aspect Ratio',
    'aspectRatio.auto': 'Auto',
    'aspectRatio.1:1': '1:1',
    'aspectRatio.4:3': '4:3',
    'aspectRatio.16:9': '16:9',
    'aspectRatio.21:9': '21:9',
    'aspectRatio.3:2': '3:2',
    'aspectRatio.9:16': '9:16',
    'aspectRatio.3:4': '3:4',
    'aspectRatio.2:3': '2:3',
    'aspectRatio.5:4': '5:4',
    'aspectRatio.4:5': '4:5',

    // Object placement (Product Packshot)
    'placement.title': 'Object placement',

    // Dimensions (Product Packshot)
    'dimensions.title': 'Dimensions',
    'dimensions.enable': 'Add product dimensions',
    'dimensions.helper': 'Approximate values in cm improve photo quality and scale.',
    'dimensions.width': 'Width (cm)',
    'dimensions.height': 'Height (cm)',
    'dimensions.depth': 'Depth (cm)',
    'dimensions.placement': 'Object placement',
    'dimensions.placement.auto': 'Auto',
    'dimensions.placement.on_ground': 'On ground / floor',
    'dimensions.placement.on_surface': 'On surface (table, stand)',
    'dimensions.placement.on_pedestal': 'On pedestal / plinth',
    'dimensions.placement.floating': 'Floating / suspended',

    // Template
    'template.title': 'Template',
    'template.none': 'None',
    'template.noTemplate': 'No template',
    'template.auto': 'Auto',

    // Scene type descriptions
    'sceneType.auto.desc': 'Let AI decide the best scene type',
    'sceneType.action.desc': 'People in motion, candid moments, dynamic interactions',

    // Common
    'common.select': 'Select...',
    'common.unitCm': 'cm',
    'label.selected': 'Selected',
    'label.removeScreenshot': 'Remove screenshot',
    'session.iteration': 'Iteration {{n}}',

    // Reference image (extended)
    'referenceImage.generatedTitle': 'Generated Reference',
    'referenceImage.lastGenerated': 'Last Generated',
    'referenceImage.lastGeneratedHelper': 'Auto-set from your last generation for iterative creation.',
    'referenceImage.add': 'Add reference image',
    'referenceImage.styleHelper': 'Upload an image as style reference',
    'referenceImage.styleReference': 'Style Reference',

    // People count options
    'people.count.1': '1',
    'people.count.2_3': '2-3',
    'people.count.3_5': '3-5',
    'people.count.5_plus': '5+',

    // Dimensions unit
    'dimensions.unit': 'cm',

    // Illustrations styles
    'illustrations.styleTitle': 'Illustration Style',
    'illustrations.style.auto': 'Auto',
    'illustrations.style.linear': 'Linear',

    // Creative packshots
    'creativePackshots.title': 'Creative Product Packshot',
    'creativePackshots.infoMain': 'Magazine-style product photography with colorful backgrounds, art-directed composition, and visual impact. Perfect for marketing, social media, and editorial content.',
    'creativePackshots.infoSub': 'Control people mode, location context, and apply brand templates.',

    // Packshot optional prompts
    'packshots.promptOptional.creative': '(optional) Describe the creative scene, mood, or styling for your product',
    'packshots.promptOptional.studio': '(optional) Define background color or specific lighting needs for studio setup',

    // Style chips (short labels)
    'styleChip.action': 'Action',
    'styleChip.mockup': 'Mockup',
    'styleChip.auto': 'Auto',
    'styleChip.linear': 'Linear',
    'styleChip.abstract': 'Abstract',

    // Rating tooltips
    'rating.star': '{{count}} star',
    'rating.stars': '{{count}} stars',

    // Mockups
    'mockups.recommendedScreen': 'Recommended for {{device}}: {{hint}}',

    // Gallery
    'gallery.info': 'Info',
    'gallery.regenerate': 'RE-Generate',
    'gallery.openSession': 'Open session',
    'gallery.session': 'Session',

    // Info panel extras
    'infoPanel.noTags': 'No tags',
    'infoPanel.addTag': 'Add tag:',
    'infoPanel.tagPlaceholder': 'Enter custom tag',
    'infoPanel.styleReference': 'Style Reference',
    'infoPanel.saving': 'Saving...',
    'infoPanel.rejected': 'Rejected',
    'infoPanel.needsReview': 'Needs Review',
    'infoPanel.approved': 'Approved',
    'button.save': 'Save',

    // Settings drawer
    'settings.closeDrawer': 'Close settings',
    'settings.openDrawer': 'Open settings',

    // Zoom
    'zoom.in': 'Zoom In',
    'zoom.out': 'Zoom Out',
    'zoom.reset': 'Reset to 100%',

    // Location extras (creative packshots)
    'location.minimalBackground': 'Minimal Background',

    // Styles (Templates gallery)
    'styles.title': 'Styles',
    'styles.subtitle': 'Browse templates and start creating',
    'styles.noTemplates': 'No templates',
    'styles.noTemplatesDesc': 'Templates will appear here when available',

    // Prompt
    'prompt.title': 'Prompt',
    'prompt.placeholder': 'Enter your prompt here...',
    'prompt.optionalWithTemplate': 'Optional with template',

    // Camera
    'camera.title': 'Camera Preset',
    'camera.auto': 'Auto (from location/sceneType)',
    'camera.custom': 'Custom (manual configuration)',
    'camera.none': 'None',

    // Camera Settings (custom config)
    'cameraSettings.customConfig': 'Custom camera configuration',
    'cameraSettings.camera': 'Camera',
    'cameraSettings.none': 'None',
    'cameraSettings.shotPlan': 'Shot plan',
    'cameraSettings.whiteBalance': 'White balance',
    'cameraSettings.focusMode': 'Focus mode',
    'cameraSettings.meteringMode': 'Metering mode',
    'cameraSettings.aperture': 'Aperture',
    'cameraSettings.shutterSpeed': 'Shutter speed',
    'cameraSettings.iso': 'ISO',
    'cameraSettings.lens': 'Lens',
    'cameraSettings.extremeCloseUp': 'Extreme close-up (ECU)',
    'cameraSettings.closeUp': 'Close-up (CU)',
    'cameraSettings.mediumCloseUp': 'Medium close-up (MCU)',
    'cameraSettings.medium': 'Medium shot (MS)',
    'cameraSettings.mediumWide': 'Medium wide (MWS)',
    'cameraSettings.wide': 'Wide shot (WS)',
    'cameraSettings.veryWide': 'Very wide (VWS)',
    'cameraSettings.extremeWide': 'Extreme wide (EWS)',
    'cameraSettings.american': 'American shot',
    'cameraSettings.twoShot': 'Two shot',
    'cameraSettings.overShoulder': 'Over the shoulder (OTS)',
    'cameraSettings.pointOfView': 'Point of view (POV)',
    'cameraSettings.daylight': 'Daylight (5500K)',
    'cameraSettings.shade': 'Shade (7500K)',
    'cameraSettings.cloudy': 'Cloudy (6500K)',
    'cameraSettings.tungsten': 'Tungsten (3200K)',
    'cameraSettings.fluorescent': 'Fluorescent (4000K)',
    'cameraSettings.flash': 'Flash (6000K)',
    'cameraSettings.customWarm': 'Custom - Warm',
    'cameraSettings.customCool': 'Custom - Cool',
    'cameraSettings.singleAf': 'AF-S (Single)',
    'cameraSettings.continuousAf': 'AF-C (Continuous)',
    'cameraSettings.manual': 'Manual',
    'cameraSettings.faceDetection': 'Face detection',
    'cameraSettings.eyeAf': 'Eye AF',
    'cameraSettings.tracking': 'Tracking',
    'cameraSettings.evaluative': 'Evaluative (Matrix)',
    'cameraSettings.centerWeighted': 'Center weighted',
    'cameraSettings.spot': 'Spot',
    'cameraSettings.partial': 'Partial',
    'cameraSettings.f1_2': 'f/1.2 - Very shallow depth of field',
    'cameraSettings.f1_4': 'f/1.4 - Shallow depth of field',
    'cameraSettings.f1_8': 'f/1.8 - Medium depth of field',
    'cameraSettings.f2_8': 'f/2.8 - Portrait',
    'cameraSettings.f4': 'f/4 - Universal',
    'cameraSettings.f5_6': 'f/5.6 - Standard',
    'cameraSettings.f8': 'f/8 - Sharp',
    'cameraSettings.f11': 'f/11 - Deep',
    'cameraSettings.f16': 'f/16 - Maximum depth',
    'cameraSettings.veryFast': '1/4000s - Very fast (freeze motion)',
    'cameraSettings.fast': '1/1000s - Fast (sports)',
    'cameraSettings.mediumFast': '1/250s - Medium (portrait)',
    'cameraSettings.mediumSpeed': '1/60s - Medium (general)',
    'cameraSettings.slow': '1/15s - Slow (motion blur)',
    'cameraSettings.verySlow': '1s - Very slow (long exposure)',
    'cameraSettings.longExposure': '30s - Long exposure (night)',
    'cameraSettings.isoLow': 'ISO 100 - Low (best quality)',
    'cameraSettings.isoMediumLow': 'ISO 200 - Medium low',
    'cameraSettings.isoMedium': 'ISO 400 - Medium (universal)',
    'cameraSettings.isoMediumHigh': 'ISO 800 - Medium high',
    'cameraSettings.isoHigh': 'ISO 1600 - High',
    'cameraSettings.isoVeryHigh': 'ISO 3200 - Very high',
    'cameraSettings.isoExtreme': 'ISO 6400+ - Extreme',
    'cameraSettings.wideAngle': 'Wide angle lens (24mm)',
    'cameraSettings.standard': 'Standard lens (50mm)',
    'cameraSettings.telephoto': 'Telephoto (200mm)',
    'cameraSettings.macro': 'Macro',
    'cameraSettings.fisheye': 'Fisheye',

    // Reference Image
    'referenceImage.title': 'Reference Image',
    'referenceImage.enable': 'Enable reference image',
    'referenceImage.helper': 'Upload an image to guide the generation',
    'referenceImage.dropZone': 'Drop image or click',

    // Reference Image for Mockup (screenshot)
    'referenceImage.mockupTitle': 'Screenshot to place on device',
    'referenceImage.mockupEnable': 'Enable screenshot on device',
    'referenceImage.mockupHelper': 'Upload a screenshot that will be placed on the device screen',

    // Product Image
    'productImage.title': 'Product Image',
    'productImage.helper': 'Add product photo for main packshot',
    'productImage.invalidType': 'Invalid image type. Please use JPEG or PNG only.',

    // Buttons
    'button.generate': 'Generate',
    'button.download': 'Download image',
    'button.toggleInfo': 'Toggle info panel',
    'button.browse': 'Browse Images',
    'button.create': 'Create Image',
    'button.edit': 'Edit',
    'button.done': 'Done',
    'button.cancel': 'Cancel',
    'button.close': 'Close',
    'button.delete': 'Delete',
    'button.apply': 'Apply',
    'button.openFolder': 'Open folder',
    'button.tryAgain': 'Try Again',
    'button.signInShort': 'Sign In',
    'button.signUpShort': 'Sign Up',
    'tooltip.openImage': 'Open image',
    'tooltip.useAsReference': 'Use as reference',
    'tooltip.download': 'Download',
    'label.referenceProductImage': 'Reference product image',
    'label.addRef': 'Add ref',
    'label.reference': 'Reference',
    'label.removeReferenceImage': 'Remove reference image',
    'label.clickToUpload': 'Click to upload',
    'label.contentReference': 'Content Reference',
    'label.brandTemplates': 'Brand Templates',
    'label.takeProductPhoto': 'Take Product Photo',
    'label.removeProductImage': 'Remove product image',
    'label.peopleDetails': 'People details',
    'label.back': 'Back',
    'templates.heading': 'Templates',
    'mockups.deviceRequired': 'Device is required for Digital Mockup',
    'auth.registrationSuccess': 'Registration Successful!',
    'auth.redirectingToSignIn': 'Redirecting to sign in...',
    'auth.securityChecking': 'Security checking...',

    // Info Panel
    'infoPanel.fileInfo': 'File Info',
    'infoPanel.filename': 'Filename:',
    'infoPanel.created': 'Created:',
    'infoPanel.cameraSettings': 'Camera Settings',
    'infoPanel.exposure': 'Exposure:',
    'infoPanel.focalLength': 'Focal Length:',
    'infoPanel.iso': 'ISO:',
    'infoPanel.whiteBalance': 'White Balance:',
    'infoPanel.focus': 'Focus:',
    'infoPanel.metering': 'Metering:',
    'infoPanel.sceneLocation': 'Scene & Location',
    'infoPanel.sceneType': 'Scene Type:',
    'infoPanel.location': 'Location:',
    'infoPanel.people': 'People:',
    'infoPanel.tags': 'Tags',
    'infoPanel.model': 'Model',
    'infoPanel.showPrompt': 'Show Final Prompt',

    // Gallery
    'gallery.loading': 'Loading gallery...',
    'gallery.noImages': 'No images yet',
    'gallery.noImagesDesc': 'Generate your first image to get started',
    'gallery.noImagesGuestDesc': 'Create a free account to save your images and access your gallery',
    'gallery.createFirst': 'Create first image',
    'gallery.loadMore': 'Load more',

    // Preview
    'preview.generating': 'Generating your image...',
    'preview.ready': 'Ready to create',
    'preview.readyDesc': 'Fill in the parameters and click Generate',
    'preview.ready.photo': 'Ready to create a photo',
    'preview.readyDesc.photo': 'Fill in the parameters and describe your photo',
    'preview.ready.illustration': 'Ready to create an illustration',
    'preview.readyDesc.illustration': 'Fill in the parameters and describe your illustration',
    'preview.ready.infographic': 'Ready to create an infographic',
    'preview.readyDesc.infographic': 'Fill in the parameters and describe your infographic',
    'preview.infographic.dropContent': 'Add content reference image',
    'preview.infographic.dropContentHelper': 'Upload a sketch or draft. AI will extract content structure and create a polished infographic.',
    'preview.ready.icon': 'Ready to create an icon',
    'preview.readyDesc.icon': 'Fill in the parameters and describe your icon',
    'preview.ready.packshot': 'Ready to create a studio product packshot',
    'preview.readyDesc.packshot': 'Define background color or lighting setup',
    'preview.ready.creative-packshot': 'Ready to create a creative product packshot',
    'preview.readyDesc.creative-packshot': 'Describe the creative scene and styling',
    'preview.ready.mockup': 'Ready to create a digital mockup',
    'preview.readyDesc.mockup': 'Upload screenshot and select device template',
    'preview.mockup.placeScreenshot': 'Place screenshot',
    'preview.packshot.dropProduct': 'Add product photo for main packshot',
    'preview.packshot.aiGenerated': 'Here will be your AI generated product',
    'preview.error': 'Error',

    // Loading
    'loading': 'Loading...',

    // Settings
    'settings.title': 'Settings',
    'settings.subtitle': 'Basic account settings.',
    'settings.profile': 'Profile',
    'settings.firstName': 'First Name',
    'settings.lastName': 'Last Name',
    'settings.email': 'Email',
    'settings.workspace': 'Workspace Name',
    'settings.workspaceName': 'Workspace name',
    'settings.workspacePlaceholder': 'My Workspace',
    'settings.password': 'Password',
    'settings.currentPassword': 'Current password',
    'settings.currentPasswordPlaceholder': 'Enter your current password',
    'settings.newPassword': 'New password',
    'settings.newPasswordPlaceholder': 'Min. 8 characters',
    'settings.confirmPassword': 'Confirm password',
    'settings.confirmPasswordPlaceholder': 'Repeat new password',
    'settings.changePassword': 'Change Password',
    'settings.updatePassword': 'Update password',
    'settings.updating': 'Updating…',
    'settings.deleteAccount': 'Delete account',
    'settings.deleteConfirm': 'Type "DELETE" to confirm',
    'settings.deleteConfirmPlaceholder': 'Type DELETE to confirm',
    'settings.deleteConfirmError': 'Type DELETE to confirm',
    'settings.deleting': 'Deleting…',
    'settings.dangerZone': 'Danger zone',
    'settings.deleteWarning': 'This will permanently delete your account.',
    'settings.save': 'Save',
    'settings.saving': 'Saving…',
    'settings.successProfile': 'Profile updated successfully',
    'settings.profileUpdated': 'Profile updated',
    'settings.profileSaveFailed': 'Failed to save profile',
    'settings.workspaceUpdateFailed': 'Failed to update workspace',
    'settings.successPassword': 'Password changed successfully',
    'settings.errorPassword': 'Current password is incorrect',
    'settings.errorPasswordMatch': 'Passwords do not match',
    'settings.passwordsNotMatch': 'Passwords do not match',
    'settings.passwordTooShort': 'New password must be at least 8 characters',
    'settings.currentPasswordRequired': 'Current password is required',
    'settings.noAuthToken': 'No auth token',
    'settings.noUserId': 'No user id',
    'settings.errorGeneral': 'An error occurred. Please try again.',

    // Dashboard
    'dashboard.title': 'Home',
    'dashboard.hello': 'Hello {{name}}',
    'dashboard.there': 'there',
    'dashboard.subtitle': 'Quick shortcuts to start creating.',
    'dashboard.recentImages': 'Recent',
    'dashboard.quickActions': 'Make a quick image',
    'dashboard.quickPackshot': 'Studio photo packshot',
    'dashboard.quickPackshotDesc': 'Clean studio packshot of your product on neutral background',
    'dashboard.quickMockup': 'Create real digital mockup',
    'dashboard.quickMockupDesc': 'Place your design or screenshot on a real device',
    'dashboard.quickArt': 'Action packshot',
    'dashboard.quickArtDesc': 'Place your product in a real-life scene with context',
    'dashboard.quickPhoto': 'Create photorealistic session',
    'dashboard.quickPhotoDesc': 'Photorealistic photo session of your product or scene',
    'dashboard.createFirst': 'Create your first image',
    'dashboard.createFirstDesc': 'Start generating amazing AI images',
    'dashboard.noImages': 'No images yet',

    // Auth
    'auth.signIn': 'Sign In',
    'auth.signUp': 'Sign Up',
    'auth.signOut': 'Sign Out',
    'auth.joinFree': 'Join for free',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.firstName': 'First Name',
    'auth.lastName': 'Last Name',
    'auth.workspaceName': 'Workspace Name',
    'auth.createAccount': 'Create Account',
    'auth.alreadyHaveAccount': 'Already have an account?',
    'auth.dontHaveAccount': "Don't have an account?",
    'auth.backToHome': 'Back to home',
    'auth.enterCredentials': 'Enter your credentials to continue',
    'auth.signingIn': 'Signing in...',
    'auth.creatingAccount': 'Creating Account...',
    'auth.completeSecurityCheck': 'Complete Security Check',
    'auth.termsAccept': 'I agree to the',
    'auth.terms': 'Terms & Conditions',
    'auth.and': 'and',
    'auth.privacy': 'Privacy Policy',
    'auth.enterEmailCode': 'Enter your email to receive a verification code',
    'auth.adminAccountDetected': 'Administrator account detected. Sign in with your password.',
    'auth.codeSentTo': 'We sent a code to {{email}}',
    'auth.enterVerificationCode': 'Enter verification code',
    'auth.sendVerificationCode': 'Send verification code',
    'auth.sendingCode': 'Sending code...',
    'auth.verifying': 'Verifying...',
    'auth.verifyAndCreateAccount': 'Verify and create account',
    'auth.verifyAndSignIn': 'Verify and sign in',
    'auth.resendCode': 'Resend code',
    'auth.useCodeInstead': 'Use code instead',
    'auth.useCodeRegistration': 'Use code registration instead',

    // Delete confirmation
    'delete.title': 'Delete Image',
    'delete.confirm': 'Are you sure you want to delete this image? This action cannot be undone.',
    'delete.cancel': 'Cancel',
    'delete.delete': 'Delete',
    'delete.deleting': 'Deleting...',
    'delete.success': 'Image deleted successfully',
    'delete.error': 'Failed to delete image',

    // Welcome modal
    'welcome.title': 'Welcome to AI Image Generator',
    'welcome.leftTitle': 'AI Image Studio',
    'welcome.leftSubtitle': 'Create stunning visuals with AI',
    'welcome.subtitle': 'Choose how you want to continue',
    'welcome.description': 'Create professional images, illustrations, and graphics powered by advanced AI technology.',
    'welcome.feature1Title': 'Realistic Photos',
    'welcome.feature1Desc': 'Generate photorealistic images with custom scenes and locations',
    'welcome.feature2Title': 'Creative Illustrations',
    'welcome.feature2Desc': 'Design unique illustrations with various styles and themes',
    'welcome.feature3Title': 'Fast Generation',
    'welcome.feature3Desc': 'Get high-quality results in seconds with our optimized AI models',
    'welcome.signIn': 'Sign In',
    'welcome.signInDesc': 'Already have an account',
    'welcome.createAccount': 'Create Account',
    'welcome.createAccountDesc': 'New user? Sign up for free',
    'welcome.continueWithout': 'Continue without account',
    'welcome.continueWithoutDesc': 'Limited features',

    // View modes
    'view.single': 'Single View',
    'view.grid': 'Grid View',

    // Rating
    'rating.title': 'Rate this image',
    'rating.submit': 'Submit Rating',
    'rating.thanks': 'Thank you for your feedback!',

    // Icons module
    'icons.title': 'Icon Generator',
    'icons.promptLabel': 'What Icon Should Represent',
    'icons.promptPlaceholder': 'Describe the icon you want to create...',
    'icons.size': 'Icon Size',
    'icons.small': 'Small (40px)',
    'icons.medium': 'Medium (64px)',
    'icons.large': 'Large (128px)',

    // Illustrations module
    'illustrations.title': 'Illustrations',
    'illustrations.promptLabel': 'Describe Your Illustration',
    'illustrations.promptPlaceholder': 'Describe the illustration you want to create...',

    // Infographics module
    'infographics.title': 'Infographics',
    'infographics.promptLabel': 'Describe Your Infographic',
    'infographics.promptPlaceholder': 'Describe the infographic you want to create...',

    // Photos module
    'photos.title': 'Real Photo',
    'photos.promptLabel': 'Describe Your Photo',
    'photos.promptPlaceholder': 'Describe the photo you want to create...',

    // Packshots module
    'packshots.title': 'Product Packshot',
    'packshots.promptLabel': 'Describe Your Product',
    'packshots.promptPlaceholder': 'Describe the product you want to photograph...',
    'packshots.productSessionTitle': 'Product Session',
    'packshots.peopleMode.title': 'People Mode',
    'packshots.peopleMode.withoutPeopleDesc': 'Product-focused composition (default)',
    'packshots.peopleMode.withPeopleDesc': 'Lifestyle interaction with product',
    'packshots.session.studio_packshot.label': 'Studio packshot',
    'packshots.session.studio_packshot.desc': 'Product on a solid background - for store and catalog',
    'packshots.session.advert_editorial.label': 'Advert editorial',
    'packshots.session.advert_editorial.desc': 'Product in an ad-style setup - props, lighting, mood',
    'packshots.session.real_session.label': 'Real session',
    'packshots.session.real_session.desc': 'Product in a real environment - home, office, street',
    'packshots.studioBackground.auto': 'Auto (neutral)',
    'packshots.studioBackground.white': 'Pure white',
    'packshots.studioBackground.off_white': 'Off-white / ivory',
    'packshots.studioBackground.light_gray': 'Light gray',
    'packshots.studioBackground.mid_gray': 'Mid gray',
    'packshots.studioBackground.black': 'Black',
    'packshots.studioBackground.beige': 'Warm beige',
    'packshots.studioBackground.pastel_blue': 'Pastel blue',
    'packshots.studioBackground.pastel_pink': 'Pastel pink',
    'packshots.studioBackground.pastel_green': 'Pastel green',
    'packshots.studioBackground.custom': 'Custom (HEX)',
    'packshots.studioCamera.auto': 'Auto',
    'packshots.studioCamera.extreme_close_up': 'Extreme close-up (detail)',
    'packshots.studioCamera.close_up': 'Close-up',
    'packshots.studioCamera.medium_close_up': 'Medium close-up',
    'packshots.studioCamera.medium': 'Medium shot',
    'packshots.studioCamera.medium_wide': 'Medium wide',
    'packshots.studioCamera.wide': 'Wide shot',
    'packshots.productReferenceTitle': 'Product Reference',
    'packshots.productReferenceLocked': 'Locked primary product source for this session.',

    // Errors
    'error.loadingFailed': 'Failed to load',
    'error.generationFailed': 'Generation failed',
    'error.networkError': 'Network error. Please try again.',
    'error.unauthorized': 'Please sign in to continue',

    // Messages
    'message.pleaseSignIn': 'Please sign in to view settings.',
    'message.fillParameters': 'Fill in the parameters and click Generate',

    // Guest Limit
    'guestLimit.title': 'Generation Limit Reached',
    'guestLimit.message': 'You have reached the limit of 3 free image generations. Create an account to continue generating unlimited images.',

    // Validation
    'validation.promptTooShort': 'Please enter at least 3 characters for the prompt or select a template',
    'validation.missingInput': 'Please add an image, enter a prompt, or select a template',
    'session.loadingHistory': 'Loading session history...',
    'session.noImages': 'No images in this session yet.',
    'preview.limitReachedTitle': 'Generation Limit Reached',
    'preview.limitReachedMessage': 'You have reached the limit of 3 free image generations. Create an account to continue generating unlimited images.',
    'preview.highDemandTitle': 'High Demand',
    'preview.highDemandMessage': 'The service is currently under heavy load. Please try again in a moment.',
    'preview.securityCheck': 'Please complete the security check',
    'error.uploadFailed': 'Failed to upload image. Please try again.',
    'error.referenceUploadFailed': 'Failed to upload reference image. Please try again.',
    'error.cameraAccess': 'Could not access camera. Please check permissions.',
    'error.invalidImageType': 'Only PNG and JPG are allowed.',
};

const pl: typeof en = {
  ...en,
  'module.photo': 'Realne Zdjęcie',
  'module.packshot': 'Sesja produktowa',
  'module.mockup': 'Makieta cyfrowa',
  'module.illustration': 'Ilustracja',
  'module.infographic': 'Infografika',
  'module.short.packshot': 'Produkt',
  'module.short.photo': 'Zdjęcie',
  'module.short.mockup': 'Mockup',
  'module.short.infographic': 'Info',
  'module.short.illustration': 'Art',
  'nav.home': 'Home',
  'nav.gallery': 'Galeria',
  'nav.account': 'Konto',
  'nav.create': 'Utwórz',
  'guest.banner.message': 'Tryb gościa - załóż konto, żeby zapisywać prace i synchronizować projekty.',
  'guest.saveBanner.message': 'Zostało {{remaining}} darmowych generacji. Załóż konto, żeby nie stracić tego zdjęcia.',
  'guest.saveBanner.cta': 'Załóż darmowe konto',
  'guest.saveBanner.signIn': 'Zaloguj się',
  'guestConsent.title': 'Wersja darmowa - publiczne zdjęcia',
  'guestConsent.message':
    'W wersji darmowej wygenerowane obrazy są publiczne i mogą być wykorzystane przez Paqshot w celach marketingowych i promocyjnych.',
  'guestConsent.privateHint':
    'Chcesz prywatności? Załóż darmowe konto - wtedy Twoje zdjęcia zostają tylko u Ciebie.',
  'guestConsent.acceptPrefix': 'Rozumiem i akceptuję',
  'guestConsent.continue': 'Kontynuuj w wersji darmowej',
  'auth.registerFree': 'Załóż darmowe konto',
  'packshots.sessionLockMessage': 'Typ sesji wybierasz tylko na początku. Aby go zmienić, rozpocznij nową sesję.',
  'packshots.studioSetup': 'Ustawienia studia',
  'packshots.studioBackgroundColor': 'Kolor tła',
  'packshots.studioCameraDistance': 'Odległość kamery',
  'packshots.studioCustomHex': 'Własny kolor (HEX)',
  'packshots.studioHexFormat': 'Format: #RRGGBB',
  'trial.active': 'Trial aktywny: pozostało {{days}} {{daysLabel}}',
  'trial.day': 'dzień',
  'trial.days': 'dni',
  'trial.upgradeNow': 'Ulepsz plan',
  'trial.openBilling': 'Otwórz rozliczenia',
  'trial.ended': 'Trial zakończony. Dodaj plan, aby kontynuować.',
  'trial.subscriptionActive': 'Subskrypcja aktywna',
  'dashboard.customSolutions.title': 'Potrzebujesz rozwiązań na miarę?',
  'dashboard.customSolutions.dev.title': 'Potrzebujesz custom developmentu?',
  'dashboard.customSolutions.dev.desc': 'Tworzymy aplikacje webowe, mobile i oprogramowanie dopasowane do Twojego biznesu.',
  'dashboard.customSolutions.dev.link': 'Zobacz squares.agency →',
  'dashboard.customSolutions.design.title': 'Potrzebujesz pomocy z designem, brandingiem, product designem?',
  'dashboard.customSolutions.design.desc': 'Profesjonalne usługi projektowe dla marek, produktów i doświadczeń cyfrowych.',
  'dashboard.customSolutions.design.link': 'Zobacz 2rep.studio →',
  'settings.ssoNotice': 'Ustawienia konta są teraz dostępne centralnie w ProseCaptain SSO.',
  'settings.openSso': 'Kliknij tutaj, aby przejść do ustawień',
  'account.billing': 'Rozliczenia',
  'account.settings': 'Ustawienia',
  'account.logout': 'Wyloguj',
  'account.credits': '{{count}} kredytów',
  'account.defaultName': 'Konto',
  'account.defaultWorkspace': 'Mój workspace',
  'language.label': 'Język',
  'language.en': 'English',
  'language.pl': 'Polski',
  'imageStyle.title': 'Styl obrazu',
  'imageStyle.photo': 'Realne Zdjęcie',
  'imageStyle.illustration': 'Ilustracja',
  'imageStyle.infographic': 'Infografika',
  'sceneType.title': 'Typ sceny',
  'sceneType.auto': 'Auto / Ogólne',
  'sceneType.action': 'Scena akcji',
  'sceneType.mockup': 'Makieta cyfrowa',
  'sceneType.abstract': 'Abstrakcyjne tło',
  'sceneType.product_packshot': 'Packshot produktu',
  'device.title': 'Wybierz urządzenie',
  'device.ipad': 'iPad / Tablet',
  'people.auto': 'Auto',
  'people.with_people': 'Z ludźmi',
  'people.without_people': 'Bez ludzi',
  'gender.diverse': 'Różnorodnie (mix)',
  'gender.women': 'Kobiety',
  'gender.men': 'Mężczyźni',
  'gender.non_binary': 'Niebinarne',
  'ethnicity.diverse': 'Różnorodnie (mix)',
  'location.title': 'Lokalizacja',
  'location.none': 'Auto',
  'location.custom': 'Własna (wpisz ręcznie)',
  'location.customPlaceholder': 'Wpisz własną lokalizację',
  'location.office': 'Biuro / Workspace',
  'location.home': 'Dom / Wnętrze',
  'location.outdoor': 'Plener',
  'location.cafe': 'Kawiarnia / Restauracja',
  'location.studio': 'Studio fotograficzne',
  'location.urban': 'Miejska / Miasto',
  'location.nature': 'Natura / Zieleń',
  'location.industrial': 'Industrialna / Loft',
  'location.minimal': 'Minimalistyczne wnętrze',
  'location.luxury': 'Luksusowe wnętrze',
  'people.title': 'Ludzie',
  'people.gender': 'Płeć',
  'people.ethnicity': 'Pochodzenie',
  'people.age': 'Przedział wieku',
  'people.count': 'Liczba osób',
  'people.interaction': 'Interakcja z produktem',
  'people.interaction.none': 'Auto',
  'people.interaction.holding': 'Trzyma produkt',
  'people.interaction.using': 'Używa produktu',
  'people.interaction.looking_at': 'Patrzy na produkt',
  'people.interaction.pointing': 'Wskazuje produkt',
  'people.interaction.in_background': 'W tle',
  'people.editDetails': 'Edytuj szczegóły osób',
  'aspectRatio.title': 'Proporcje',
  'placement.title': 'Położenie obiektu',
  'dimensions.title': 'Wymiary',
  'dimensions.enable': 'Dodaj wymiary produktu',
  'dimensions.helper': 'Przybliżone wartości w cm poprawiają jakość i skalę zdjęcia.',
  'dimensions.width': 'Szerokość (cm)',
  'dimensions.height': 'Wysokość (cm)',
  'dimensions.depth': 'Głębokość (cm)',
  'dimensions.placement': 'Położenie obiektu',
  'dimensions.placement.auto': 'Auto',
  'dimensions.placement.on_ground': 'Na podłodze',
  'dimensions.placement.on_surface': 'Na powierzchni (stół, blat)',
  'dimensions.placement.on_pedestal': 'Na postumencie',
  'dimensions.placement.floating': 'Zawieszony / lewitujący',
  'template.title': 'Szablon',
  'template.none': 'Brak',
  'template.noTemplate': 'Bez szablonu',
  'template.auto': 'Auto',
  'sceneType.auto.desc': 'AI samo dobiera najlepszy typ sceny',
  'sceneType.action.desc': 'Ludzie w ruchu, spontaniczne momenty, dynamiczne interakcje',
  'common.select': 'Wybierz...',
  'common.unitCm': 'cm',
  'label.selected': 'Wybrano',
  'label.removeScreenshot': 'Usuń screenshot',
  'session.iteration': 'Iteracja {{n}}',
  'referenceImage.generatedTitle': 'Wygenerowana referencja',
  'referenceImage.lastGenerated': 'Ostatnia generacja',
  'referenceImage.lastGeneratedHelper': 'Automatycznie ustawione z ostatniej generacji do iteracyjnej pracy.',
  'referenceImage.add': 'Dodaj referencję',
  'referenceImage.styleHelper': 'Wgraj zdjęcie jako inspirację stylu',
  'referenceImage.styleReference': 'Styl referencyjny',
  'people.count.1': '1',
  'people.count.2_3': '2-3',
  'people.count.3_5': '3-5',
  'people.count.5_plus': '5+',
  'dimensions.unit': 'cm',
  'illustrations.styleTitle': 'Styl ilustracji',
  'illustrations.style.auto': 'Auto',
  'illustrations.style.linear': 'Liniowa',
  'creativePackshots.title': 'Kreatywny packshot',
  'creativePackshots.infoMain': 'Kolorowe tło, aranżacja i mocny efekt wizualny - idealne do social mediów, reklam i contentu.',
  'creativePackshots.infoSub': 'Ustaw tryb z ludźmi, lokalizację i szablony marki.',
  'packshots.promptOptional.creative': '(opcjonalnie) Opisz scenę, nastrój lub styl',
  'packshots.promptOptional.studio': '(opcjonalnie) Kolor tła lub oświetlenie',
  'styleChip.action': 'Akcja',
  'styleChip.mockup': 'Mockup',
  'styleChip.auto': 'Auto',
  'styleChip.linear': 'Liniowa',
  'styleChip.abstract': 'Abstrakcja',
  'rating.star': '{{count}} gwiazdka',
  'rating.stars': '{{count}} gwiazdki',
  'mockups.recommendedScreen': 'Zalecane dla {{device}}: {{hint}}',
  'gallery.info': 'Info',
  'gallery.regenerate': 'Generuj ponownie',
  'gallery.openSession': 'Otwórz sesję',
  'gallery.session': 'Sesja',
  'infoPanel.noTags': 'Brak tagów',
  'infoPanel.addTag': 'Dodaj tag:',
  'infoPanel.tagPlaceholder': 'Wpisz własny tag',
  'infoPanel.styleReference': 'Referencja stylu',
  'infoPanel.saving': 'Zapisywanie...',
  'infoPanel.rejected': 'Odrzucono',
  'infoPanel.needsReview': 'Do weryfikacji',
  'infoPanel.approved': 'Zaakceptowano',
  'button.save': 'Zapisz',
  'settings.closeDrawer': 'Zamknij ustawienia',
  'settings.openDrawer': 'Otwórz ustawienia',
  'zoom.in': 'Powiększ',
  'zoom.out': 'Pomniejsz',
  'zoom.reset': 'Reset do 100%',
  'location.minimalBackground': 'Minimalne tło',
  'styles.title': 'Style',
  'styles.subtitle': 'Przeglądaj szablony i zacznij tworzyć',
  'styles.noTemplates': 'Brak szablonów',
  'styles.noTemplatesDesc': 'Szablony pojawią się tutaj, gdy będą dostępne',
  'prompt.title': 'Prompt',
  'prompt.placeholder': 'Wpisz prompt...',
  'prompt.optionalWithTemplate': 'Opcjonalnie przy szablonie',
  'camera.title': 'Preset aparatu',
  'camera.auto': 'Auto (z lokalizacji/typu sceny)',
  'camera.custom': 'Własne (ręczna konfiguracja)',
  'camera.none': 'Brak',
  'referenceImage.title': 'Zdjęcie referencyjne',
  'referenceImage.enable': 'Użyj zdjęcia referencyjnego',
  'referenceImage.helper': 'Wgraj zdjęcie, które poprowadzi generację',
  'referenceImage.dropZone': 'Upuść zdjęcie lub kliknij',
  'referenceImage.mockupTitle': 'Screenshot na urządzenie',
  'referenceImage.mockupEnable': 'Włącz screenshot na ekranie',
  'referenceImage.mockupHelper': 'Wgraj screenshot - pojawi się na ekranie urządzenia',
  'productImage.title': 'Zdjęcie produktu',
  'productImage.helper': 'Dodaj zdjęcie produktu',
  'productImage.invalidType': 'Nieprawidłowy typ pliku. Użyj tylko JPEG albo PNG.',
  'button.generate': 'Generuj',
  'button.download': 'Pobierz obraz',
  'button.toggleInfo': 'Przełącz panel informacji',
  'button.browse': 'Galeria',
  'button.create': 'Twórz',
  'button.edit': 'Edytuj',
  'button.done': 'Gotowe',
  'button.cancel': 'Anuluj',
  'button.close': 'Zamknij',
  'button.delete': 'Usuń',
  'button.apply': 'Zastosuj',
  'button.openFolder': 'Otwórz folder',
  'button.tryAgain': 'Spróbuj ponownie',
  'button.signInShort': 'Zaloguj',
  'button.signUpShort': 'Załóż konto',
  'tooltip.openImage': 'Otwórz obraz',
  'tooltip.useAsReference': 'Użyj jako referencji',
  'tooltip.download': 'Pobierz',
  'label.referenceProductImage': 'Zdjęcie produktu',
  'label.addRef': 'Dodaj ref',
  'label.reference': 'Referencja',
  'label.removeReferenceImage': 'Usuń referencję',
  'label.clickToUpload': 'Kliknij, aby wgrać',
  'label.contentReference': 'Referencja treści',
  'label.brandTemplates': 'Szablony brandowe',
  'label.takeProductPhoto': 'Zrób zdjęcie produktu',
  'label.removeProductImage': 'Usuń zdjęcie produktu',
  'label.peopleDetails': 'Szczegóły osób',
  'label.back': 'Wstecz',
  'templates.heading': 'Szablony',
  'mockups.deviceRequired': 'Urządzenie jest wymagane dla Digital Mockup',
  'auth.registrationSuccess': 'Rejestracja zakończona sukcesem!',
  'auth.redirectingToSignIn': 'Przekierowanie do logowania...',
  'auth.securityChecking': 'Sprawdzanie bezpieczeństwa...',
  'infoPanel.fileInfo': 'Informacje o pliku',
  'infoPanel.filename': 'Nazwa pliku:',
  'infoPanel.created': 'Utworzono:',
  'infoPanel.cameraSettings': 'Ustawienia aparatu',
  'infoPanel.sceneLocation': 'Scena i lokalizacja',
  'infoPanel.sceneType': 'Typ sceny:',
  'infoPanel.location': 'Lokalizacja:',
  'infoPanel.people': 'Ludzie:',
  'infoPanel.tags': 'Tagi',
  'infoPanel.model': 'Model',
  'infoPanel.showPrompt': 'Pokaż finalny prompt',
  'gallery.loading': 'Ładowanie galerii...',
  'gallery.noImages': 'Brak obrazów',
  'gallery.noImagesDesc': 'Wygeneruj pierwszy obraz, aby zacząć',
  'gallery.noImagesGuestDesc': 'Załóż konto, żeby zapisywać zdjęcia i korzystać z galerii',
  'gallery.createFirst': 'Wygeneruj pierwsze zdjęcie',
  'gallery.loadMore': 'Załaduj więcej',
  'preview.generating': 'Generowanie obrazu...',
  'preview.ready': 'Gotowe do generacji',
  'preview.readyDesc': 'Ustaw parametry i kliknij Generuj',
  'preview.ready.photo': 'Gotowe do zdjęcia',
  'preview.readyDesc.photo': 'Ustaw parametry i opisz scenę',
  'preview.ready.illustration': 'Gotowe do ilustracji',
  'preview.readyDesc.illustration': 'Ustaw parametry i opisz ilustrację',
  'preview.ready.infographic': 'Gotowe do infografiki',
  'preview.readyDesc.infographic': 'Ustaw parametry i opisz infografikę',
  'preview.infographic.dropContent': 'Dodaj szkic lub materiał źródłowy',
  'preview.infographic.dropContentHelper': 'Wgraj szkic lub draft - AI zbuduje z niego infografikę.',
  'preview.ready.icon': 'Gotowe do ikony',
  'preview.readyDesc.icon': 'Ustaw parametry i opisz ikonę',
  'preview.ready.packshot': 'Gotowy packshot studyjny',
  'preview.readyDesc.packshot': 'Ustaw tło lub oświetlenie',
  'preview.ready.creative-packshot': 'Gotowy kreatywny packshot',
  'preview.readyDesc.creative-packshot': 'Opisz scenę i styl',
  'preview.ready.mockup': 'Gotowa makieta',
  'preview.readyDesc.mockup': 'Wgraj screenshot i wybierz urządzenie',
  'preview.mockup.placeScreenshot': 'Umieść screenshot',
  'preview.packshot.dropProduct': 'Dodaj zdjęcie produktu',
  'preview.packshot.aiGenerated': 'Tutaj pojawi się wygenerowany produkt',
  'preview.error': 'Błąd',
  'loading': 'Ładowanie...',
  'settings.title': 'Ustawienia',
  'settings.subtitle': 'Podstawowe ustawienia konta.',
  'settings.profile': 'Profil',
  'settings.firstName': 'Imię',
  'settings.lastName': 'Nazwisko',
  'settings.email': 'Email',
  'settings.workspace': 'Nazwa workspace',
  'settings.workspaceName': 'Nazwa workspace',
  'settings.workspacePlaceholder': 'Mój Workspace',
  'settings.password': 'Hasło',
  'settings.currentPassword': 'Aktualne hasło',
  'settings.currentPasswordPlaceholder': 'Wpisz aktualne hasło',
  'settings.newPassword': 'Nowe hasło',
  'settings.newPasswordPlaceholder': 'Min. 8 znaków',
  'settings.confirmPassword': 'Potwierdź hasło',
  'settings.confirmPasswordPlaceholder': 'Powtórz nowe hasło',
  'settings.changePassword': 'Zmień hasło',
  'settings.updatePassword': 'Aktualizuj hasło',
  'settings.updating': 'Aktualizowanie…',
  'settings.deleteAccount': 'Usuń konto',
  'settings.deleteConfirm': 'Wpisz "DELETE", aby potwierdzić',
  'settings.deleteConfirmPlaceholder': 'Wpisz DELETE, aby potwierdzić',
  'settings.deleteConfirmError': 'Wpisz DELETE, aby potwierdzić',
  'settings.deleting': 'Usuwanie…',
  'settings.dangerZone': 'Strefa ryzyka',
  'settings.deleteWarning': 'To bezpowrotnie usunie Twoje konto.',
  'settings.save': 'Zapisz',
  'settings.saving': 'Zapisywanie…',
  'dashboard.title': 'Home',
  'dashboard.hello': 'Cześć {{name}}',
  'dashboard.there': 'tam',
  'dashboard.subtitle': 'Szybkie skróty do tworzenia.',
  'dashboard.recentImages': 'Ostatnie',
  'dashboard.quickActions': 'Szybki start',
  'dashboard.quickPackshot': 'Packshot studyjny',
  'dashboard.quickPackshotDesc': 'Czysty packshot na neutralnym tle',
  'dashboard.quickMockup': 'Makieta na urządzeniu',
  'dashboard.quickMockupDesc': 'Umieść projekt lub screenshot na ekranie',
  'dashboard.quickArt': 'Packshot w scenie',
  'dashboard.quickArtDesc': 'Produkt w realistycznym otoczeniu',
  'dashboard.quickPhoto': 'Sesja fotograficzna',
  'dashboard.quickPhotoDesc': 'Fotorealistyczna scena lub produkt',
  'dashboard.createFirst': 'Wygeneruj pierwsze zdjęcie',
  'dashboard.createFirstDesc': 'Zacznij tworzyć z AI',
  'dashboard.noImages': 'Brak obrazów',
  'auth.signIn': 'Zaloguj się',
  'auth.signUp': 'Załóż konto',
  'auth.signOut': 'Wyloguj',
  'auth.joinFree': 'Dołącz za darmo',
  'auth.firstName': 'Imię',
  'auth.lastName': 'Nazwisko',
  'auth.workspaceName': 'Nazwa workspace',
  'auth.createAccount': 'Utwórz konto',
  'auth.alreadyHaveAccount': 'Masz już konto?',
  'auth.dontHaveAccount': 'Nie masz konta?',
  'auth.backToHome': 'Wróć do strony głównej',
  'auth.enterCredentials': 'Wpisz dane logowania, aby kontynuować',
  'auth.signingIn': 'Logowanie...',
  'auth.creatingAccount': 'Tworzenie konta...',
  'auth.completeSecurityCheck': 'Ukończ weryfikację bezpieczeństwa',
  'auth.termsAccept': 'Akceptuję',
  'auth.terms': 'Regulamin',
  'auth.and': 'i',
  'auth.privacy': 'Politykę prywatności',
  'auth.enterEmailCode': 'Wpisz email, aby otrzymać kod weryfikacyjny',
  'auth.adminAccountDetected': 'Wykryto konto administratora. Zaloguj się hasłem.',
  'auth.codeSentTo': 'Wysłaliśmy kod na {{email}}',
  'auth.enterVerificationCode': 'Wpisz kod weryfikacyjny',
  'auth.sendVerificationCode': 'Wyślij kod weryfikacyjny',
  'auth.sendingCode': 'Wysyłanie kodu...',
  'auth.verifying': 'Weryfikowanie...',
  'auth.verifyAndCreateAccount': 'Zweryfikuj i utwórz konto',
  'auth.verifyAndSignIn': 'Zweryfikuj i zaloguj się',
  'auth.resendCode': 'Wyślij kod ponownie',
  'auth.useCodeInstead': 'Użyj kodu zamiast hasła',
  'auth.useCodeRegistration': 'Zarejestruj się przez kod',
  'delete.title': 'Usuń obraz',
  'delete.confirm': 'Czy na pewno chcesz usunąć ten obraz? Tej operacji nie można cofnąć.',
  'delete.cancel': 'Anuluj',
  'delete.delete': 'Usuń',
  'delete.deleting': 'Usuwanie...',
  'delete.success': 'Obraz został usunięty',
  'delete.error': 'Nie udało się usunąć obrazu',
  'welcome.title': 'Witaj w AI Image Generator',
  'welcome.leftTitle': 'AI Image Studio',
  'welcome.leftSubtitle': 'Twórz świetne wizuale z AI',
  'welcome.subtitle': 'Wybierz, jak chcesz kontynuować',
  'welcome.description': 'Twórz profesjonalne obrazy, ilustracje i grafiki z pomocą zaawansowanej AI.',
  'welcome.feature1Title': 'Realistyczne zdjęcia',
  'welcome.feature1Desc': 'Generuj fotorealistyczne obrazy z własnymi scenami i lokalizacjami',
  'welcome.feature2Title': 'Kreatywne ilustracje',
  'welcome.feature2Desc': 'Projektuj unikalne ilustracje w różnych stylach',
  'welcome.feature3Title': 'Szybka generacja',
  'welcome.feature3Desc': 'Otrzymuj wysoką jakość w kilka sekund',
  'welcome.signIn': 'Zaloguj się',
  'welcome.signInDesc': 'Masz już konto',
  'welcome.createAccount': 'Utwórz konto',
  'welcome.createAccountDesc': 'Nowy użytkownik? Załóż konto za darmo',
  'welcome.continueWithout': 'Kontynuuj bez konta',
  'welcome.continueWithoutDesc': 'Ograniczone funkcje',
  'view.single': 'Widok pojedynczy',
  'view.grid': 'Widok siatki',
  'rating.title': 'Oceń ten obraz',
  'rating.submit': 'Wyślij ocenę',
  'rating.thanks': 'Dzięki za feedback!',
  'icons.title': 'Generator ikon',
  'icons.promptLabel': 'Co ma przedstawiać ikona',
  'icons.promptPlaceholder': 'Opisz ikonę, którą chcesz stworzyć...',
  'icons.size': 'Rozmiar ikony',
  'icons.small': 'Mała (40px)',
  'icons.medium': 'Średnia (64px)',
  'icons.large': 'Duża (128px)',
  'illustrations.title': 'Ilustracje',
  'illustrations.promptLabel': 'Opisz ilustrację',
  'illustrations.promptPlaceholder': 'Opisz ilustrację, którą chcesz stworzyć...',
  'infographics.title': 'Infografiki',
  'infographics.promptLabel': 'Opisz infografikę',
  'infographics.promptPlaceholder': 'Opisz infografikę, którą chcesz stworzyć...',
  'photos.title': 'Realne zdjęcie',
  'photos.promptLabel': 'Opisz zdjęcie',
  'photos.promptPlaceholder': 'Opisz zdjęcie, które chcesz stworzyć...',
  'packshots.title': 'Packshot',
  'packshots.promptLabel': 'Opisz produkt',
  'packshots.promptPlaceholder': 'Co chcesz sfotografować?',
  'packshots.productSessionTitle': 'Sesja produktowa',
  'packshots.peopleMode.title': 'Ludzie w kadrze',
  'packshots.peopleMode.withoutPeopleDesc': 'Tylko produkt (domyślnie)',
  'packshots.peopleMode.withPeopleDesc': 'Lifestyle - produkt z ludźmi',
  'packshots.session.studio_packshot.label': 'Packshot studyjny',
  'packshots.session.studio_packshot.desc': 'Produkt na jednolitym tle - do sklepu i katalogu',
  'packshots.session.advert_editorial.label': 'Editorial reklamowy',
  'packshots.session.advert_editorial.desc': 'Produkt w aranżacji reklamowej - rekwizyty, światło, klimat',
  'packshots.session.real_session.label': 'Realna sesja',
  'packshots.session.real_session.desc': 'Produkt w prawdziwym otoczeniu - dom, biuro, ulica',
  'packshots.studioBackground.auto': 'Auto (neutralne)',
  'packshots.studioBackground.white': 'Biały',
  'packshots.studioBackground.off_white': 'Off-white / kość słoniowa',
  'packshots.studioBackground.light_gray': 'Jasny szary',
  'packshots.studioBackground.mid_gray': 'Średni szary',
  'packshots.studioBackground.black': 'Czarny',
  'packshots.studioBackground.beige': 'Ciepły beż',
  'packshots.studioBackground.pastel_blue': 'Pastelowy niebieski',
  'packshots.studioBackground.pastel_pink': 'Pastelowy róż',
  'packshots.studioBackground.pastel_green': 'Pastelowy zielony',
  'packshots.studioBackground.custom': 'Własny (HEX)',
  'packshots.studioCamera.auto': 'Auto',
  'packshots.studioCamera.extreme_close_up': 'Bardzo blisko (detal)',
  'packshots.studioCamera.close_up': 'Zbliżenie',
  'packshots.studioCamera.medium_close_up': 'Średnie zbliżenie',
  'packshots.studioCamera.medium': 'Ujęcie średnie',
  'packshots.studioCamera.medium_wide': 'Średnio szerokie',
  'packshots.studioCamera.wide': 'Ujęcie szerokie',
  'packshots.productReferenceTitle': 'Zdjęcie produktu',
  'packshots.productReferenceLocked': 'W tej sesji zdjęcie produktu jest zablokowane.',
  'error.loadingFailed': 'Nie udało się załadować',
  'error.generationFailed': 'Generowanie nie powiodło się',
  'error.networkError': 'Błąd sieci. Spróbuj ponownie.',
  'error.unauthorized': 'Zaloguj się, aby kontynuować',
  'message.pleaseSignIn': 'Zaloguj się, aby wyświetlić ustawienia.',
  'message.fillParameters': 'Ustaw parametry i kliknij Generuj',
  'guestLimit.title': 'Limit generacji osiągnięty',
  'guestLimit.message': 'Wykorzystałeś 3 darmowe generacje. Załóż konto, żeby generować dalej.',
  'validation.promptTooShort': 'Wpisz min. 3 znaki albo wybierz szablon',
  'validation.missingInput': 'Dodaj zdjęcie, wpisz prompt albo wybierz szablon',
  'session.loadingHistory': 'Ładowanie historii sesji...',
  'session.noImages': 'W tej sesji nie ma jeszcze obrazów.',
  'preview.limitReachedTitle': 'Osiągnięto limit generacji',
  'preview.limitReachedMessage': 'Wykorzystałeś 3 darmowe generacje. Załóż konto, żeby generować dalej.',
  'preview.highDemandTitle': 'Duże obciążenie',
  'preview.highDemandMessage': 'Usługa jest chwilowo mocno obciążona. Spróbuj ponownie za moment.',
  'preview.securityCheck': 'Dokończ weryfikację bezpieczeństwa',
  'error.uploadFailed': 'Nie udało się wgrać obrazu. Spróbuj ponownie.',
  'error.referenceUploadFailed': 'Nie udało się wgrać obrazu referencyjnego. Spróbuj ponownie.',
  'error.cameraAccess': 'Brak dostępu do kamery. Sprawdź uprawnienia.',
  'error.invalidImageType': 'Dozwolone są tylko PNG i JPG.',
};

export const translations = {
  en,
  pl,
};

export type TranslationKey = keyof typeof translations.en;
export type Language = keyof typeof translations;
